module.exports = __webpack_public_path__ + "img/boy.daf5c0e3.png";